













































































import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Form } from '@ss/mtd-vue';

import FieldShow from './customForm/field-show.vue';
import FieldEdit from './customForm/field-edit.vue';
import FormIndex from './customForm/form/formIndex.vue';
import CustomPreview from './custom-preview.vue';

import store from '@/store';
import * as api from '@/api';

import { pick } from 'lodash';

// 全局注册拖拽组件
import { Container, Draggable } from 'vue-smooth-dnd';
import { ThirdFieldUtils } from '@/utils/business';
Vue.component('Container', Container);
Vue.component('Draggable', Draggable);

const validateName: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('模板名称不能为空'));
    }
    if (value.length > 60) {
        return callback(new Error('模板名称不能超过30个字'));
    }
    return callback();
};
const validateInstruction: Function = (_rule, value, callback) => {
    if (value && value.length > 100) {
        return callback(new Error('模板说明不能超过100个字'));
    }
    return callback();
};

/**
 *  迁移页面
 *
 * @author liyuyao
 * @date 03/12/2019
 */
@Component({
    components: {
        FieldShow,
        FormIndex,
        FieldEdit,
        CustomPreview
    }
})
export default class CustomFormEdit extends Vue {
    @State(state => state.cti.systemFields)
    systemFields: CommonTypes.mapObject[];

    @Mutation setRgSetting;

    $refs: { totalForm: Form; hiddenFields: FormIndex; visibleFields: FormIndex };
    customBasicForm: CommonTypes.mapObject = {
        name: '',
        instruction: ''
    };
    addFieldVisible: boolean = false;

    btnLoading: boolean = false;

    configList: any = [];

    currentField: any = {};
    currentPos: number = null;

    isFold: string = '0';

    showPreview: boolean = false;

    hiddenFields: any = [];
    visibleFields: any = [];

    groupConfigList: any = [];

    // defaultRgSetting: CommonTypes.mapObject = {};

    ruleCustom = {
        name: [{ validator: validateName, trigger: 'blur' }],
        instruction: [{ validator: validateInstruction, trigger: 'blur' }]
    };

    async mounted() {
        if (!this.systemFields || !this.systemFields.length) {
            await this.getSystemFields();
        }
        if (!this.formId) {
            // const listShow = this.systemFields.filter((item) => {
            //     return !foldSys.includes(item.identify);
            // });
            this.separateVisibleHidden(this.systemFields);
        } else {
            this.getCustomFormDetail(this.formId);
        }
        // window.onbeforeunload = () => {
        //     return '确定要离开吗，离开后数据不会保存';
        // };
    }

    beforeDestroy() {
        window.onbeforeunload = () => {};
    }

    // 获取系统字段
    async getSystemFields() {
        const res = await api.rgApi.getSystemFields(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            store.commit(
                'GET_SYSTEM_SETTINGS',
                data.items.filter(item => {
                    return item.identify !== 'city';
                })
            );
        }
    }
    separateVisibleHidden(list) {
        const visibleArr = [];
        const hiddenArr = [];
        list.forEach(field => {
            if (field.identify === 'city') {
                return;
            }
            // 将系统字段的默认属性转换为字段属性
            if (field.isRequired === undefined) {
                field.isRequired = field.defaultAttributes.isRequired;
            }
            if (field.isHidden === undefined) {
                field.isHidden = field.defaultAttributes.isHidden;
            }
            if (field.extraSettings === undefined && field.defaultAttributes && field.defaultAttributes.extraSettings) {
                field.extraSettings = field.defaultAttributes.extraSettings;
            }
            if (field.isHidden) {
                hiddenArr.push(field);
            } else {
                visibleArr.push(field);
            }
        });
        this.groupConfigList = visibleArr.concat(hiddenArr);
        this.hiddenFields = hiddenArr;
        this.visibleFields = visibleArr;
    }

    async getCustomFormDetail(id) {
        const res = await api.rgApi.getCustomFormDetail(id, true);
        const { code, data } = res;
        if (code === 200) {
            this.customBasicForm.name = data.name;
            this.customBasicForm.instruction = data.instruction;
            this.separateVisibleHidden(data.customFieldContents);
        }
    }

    preview() {
        this.showPreview = true;
    }

    async submit() {
        interface AddParams {
            customFieldContents: any;
            rgId: number;
            type: string;
            id?: number;
        }

        /**
         * 展开内部包含的所有字段.
         */
        const flattenCustomFieldContents = async params => {
            const newCustomFieldContents = [];
            console.log(params.customFieldContents);
            for (let i = 0; i < params.customFieldContents.length; i++) {
                const item = params.customFieldContents[i];
                const isThirdField = item.type === 3;
                if (!isThirdField) {
                    newCustomFieldContents.push(item);
                    continue;
                }

                // 应该用store存配置的，这里直接请求了
                // 请求三方字段包详细信息
                try {
                    const res = await api.rgApi.getThirdFormDetail({
                        formId: item.id,
                        sourceRgId: this.rgId
                    });

                    if (res.code === 200 && res.data) {
                        // 将三方字段信息添加到当前字段中
                        const thirdFormFields = res.data.customFieldContents || [];
                        newCustomFieldContents.push(...thirdFormFields);
                    }
                } catch (error) {
                    console.error('获取三方字段详情失败', error);
                }
            }

            params.customFieldContents = newCustomFieldContents;
        };

        this.$refs.totalForm
            .validate(async valid => {
                if (valid) {
                    const addParams: AddParams = {
                        customFieldContents: this.totalRes,
                        rgId: this.rgId,
                        type: '定制表单'
                    };
                    this.formId && (addParams.id = this.formId);
                    const params = Object.assign(this.customBasicForm, addParams);
                    await flattenCustomFieldContents(params);
                    const res = await api.rgApi.addRgCustomTemplate(params);
                    const { code, data } = res;
                    const link = data.copyLink || '';
                    if (code === 200) {
                        this.$mtd
                            .confirm({
                                title: '保存成功',
                                message: `<a target="_blank" href="${link}">${link}</a>`,
                                dangerouslyUseHTMLString: true,
                                width: '433px',
                                showCancelButton: true,
                                type: 'success',
                                okButtonText: '复制链接',
                                cancelButtonText: '关闭',
                                onOk: () => {
                                    const input = document.createElement('input');
                                    document.body.appendChild(input);
                                    input.setAttribute('value', link);
                                    input.select();
                                    if (document.execCommand('copy')) {
                                        document.execCommand('copy');
                                        this.$mtd.message.success('复制成功');
                                        // remove input
                                        input.parentElement.removeChild(input);
                                    }
                                    this.$router
                                        .push({
                                            name: 'rg_template_custom',
                                            query: {
                                                rgId: `${this.rgId}`
                                            }
                                        })
                                        .catch(e => e);
                                },
                                onCancel: () => {
                                    this.$router
                                        .push({
                                            name: 'rg_template_custom',
                                            query: {
                                                rgId: `${this.rgId}`
                                            }
                                        })
                                        .catch(e => e);
                                }
                            })
                            .catch(e => e);
                    }
                }
            })
            .catch(e => e);
    }

    // 取消编辑
    cancelBack() {
        this.$mtd
            .confirm({
                message: '确定要离开吗？系统可能不会保存您所做的更改',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: () => {
                    this.$router
                        .push({
                            name: 'rg_template_custom',
                            query: {
                                rgId: `${this.rgId}`
                            }
                        })
                        .catch(e => e);
                }
            })
            .catch(e => e);
    }
    editFieldItem(field, index) {
        const ref = this.$refs.hiddenFields;
        ref && ref.clearEditStatus();
        this.currentField = field;
        this.currentPos = index;
    }
    editHiddenFieldItem(field, index) {
        // 清除另一个表单的选中态
        const ref = this.$refs.visibleFields;
        ref && ref.clearEditStatus();
        this.currentField = field;
        this.currentPos = this.visibleFields.length + index;
    }
    hiddenChange(isHidden) {
        const ref = isHidden ? this.$refs.visibleFields : this.$refs.hiddenFields;
        ref && ref.setFirstStatus();
    }
    fieldEditChange(editConfig, pos) {
        // 如果是系统字段，还要保留它defaultAttributes和editableFields的默认设置，再加上
        if (editConfig.type === 1) {
            const sysField = this.systemFields.find(item => {
                return item.identify === editConfig.identify;
            });
            editConfig = Object.assign(editConfig, {
                defaultAttributes: sysField.defaultAttributes
            });
        }
        const refVisibleFields = this.$refs.visibleFields;
        const refHiddenFields = this.$refs.hiddenFields;
        if (editConfig.identify) {
            pos = this.groupConfigList.findIndex(item => editConfig.identify === item.identify);
            if (editConfig.isHidden && refHiddenFields) {
                refHiddenFields.activeKey = editConfig.identify;
            }
            if (!editConfig.isHidden && refVisibleFields) {
                refVisibleFields.activeKey = editConfig.identify;
            }
        }
        this.$set(this.groupConfigList, pos, editConfig);
        this.separateVisibleHidden(this.groupConfigList);
    }
    visibleSchemaChange(schema) {
        this.visibleFields = schema;
        this.groupConfigList = this.visibleFields.concat(this.hiddenFields);
    }
    hiddenSchemaChange(schema) {
        this.hiddenFields = schema;
        this.groupConfigList = this.visibleFields.concat(this.hiddenFields);
    }
    formatDefaultCc(userMap) {
        return Object.keys(userMap).map(user => {
            return {
                displayName: userMap[user],
                username: user
            };
        });
    }

    get totalRes() {
        const total = this.visibleFields.concat(this.hiddenFields);
        const sysKey = ['id', 'name', 'instruction', 'type', 'identify', 'options', 'defaultValue', 'isRequired', 'isHidden', 'extraSettings'];
        const customKey = ['id', 'name', 'instruction', 'type', 'inputType', 'options', 'defaultValue', 'isRequired', 'isHidden', 'extraSettings'];

        const totalRes = total.map(item => {
            const keys = item.type === 1 ? sysKey : customKey;
            const fieldData = pick(item, keys);
            if (item.extraSettings && item.extraSettings.thirdFormId) {
                // 确保extraSettings被正确复制
                fieldData.extraSettings = { ...item.extraSettings };
            }
            return fieldData;
        });
        return totalRes;
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    get formId() {
        return parseInt(this.$route.query.formId as string, 10);
    }
}
